module.exports = __webpack_public_path__ + "static/media/sale.4d2b7950.jpg";